import React, { useEffect, useState } from "react";
import bymoLogo from "./img/bymo.png"; // Adjust the path if necessary
import "./App.css"; // Ensure the CSS file path is correct

const AdminOrders = () => {
    const [ordersData, setOrdersData] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        const fetchOrders = async () => {
            try {
                const response = await fetch("https://bymolive-backend-995926394015.us-central1.run.app/api/all-collections");
                const data = await response.json();

                if (!response.ok) {
                    throw new Error(data.error || "Failed to fetch orders.");
                }

                // Transform and sort data by order date (latest first)
                const formattedOrders = [];

                Object.entries(data).forEach(([collectionId, documents]) => {
                    const code = documents.find((doc) => doc.id === "00info")?.["Cod Reducere"] || "N/A";
                    const orders = documents.filter((doc) => doc.id !== "00info").map((order) => ({
                        collectionId,
                        code,
                        date: order.date || "", // Keep empty dates for sorting to the end
                        amount: order.amount || 0,
                        comision: order.comision || 0,
                        id: order.id || "N/A",
                        status: order.status || "N/A",
                    }));

                    formattedOrders.push(...orders);
                });

                // Sort by date (latest first, empty dates at the end)
                formattedOrders.sort((a, b) => new Date(b.date) - new Date(a.date) || (a.date === "" ? 1 : -1));

                setOrdersData(formattedOrders);
            } catch (err) {
                setError(err.message);
            } finally {
                setLoading(false);
            }
        };

        fetchOrders();
    }, []);

    return (
        <div className="admin-orders-container">
            <div className="logo-container">
                <img src={bymoLogo} alt="BYMO Logo" className="bymo-logo" />
            </div>
            <h1 className="orders-title">Orders Overview</h1>

            {loading ? (
                <p>Loading orders...</p>
            ) : error ? (
                <p className="error-message">{error}</p>
            ) : (
                <table className="orders-table">
                    <thead>
                    <tr>
                        <th>Order date</th>
                        <th>Collection ID</th>
                        <th>Code</th>

                        <th>Amount</th>
                        <th>Comision</th>
                        <th>Order ID</th>
                        <th>Status</th>
                    </tr>
                    </thead>
                    <tbody>
                    {ordersData.map((order, index) => (
                        <tr key={index}>
                            <td>{order.date}</td>
                            <td>{order.collectionId}</td>
                            <td>{order.code}</td>

                            <td>{order.amount.toFixed(2)} RON</td>
                            <td>{order.comision.toFixed(2)} RON</td>
                            <td>{order.id}</td>
                            <td>{order.status}</td>
                        </tr>
                    ))}
                    </tbody>
                </table>
            )}
        </div>
    );
};

export default AdminOrders;
